<template>
  <b-modal
    id="modal-delete-phone"
    v-model="showModal"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    size="sm"
    @hidden="onCancel"
  >
    <div class="p-1 text-center">
      <!-- Warning Icon -->
      <div class="d-flex justify-content-center mb-2">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="Warning"
          class="w-14 h-14"
        >
      </div>

      <!-- Title -->
      <h4 class="text-lg font-bold text-[#333333] mb-1">
        Hapus Nomor CS AI?
      </h4>

      <!-- Description -->
      <p class="text-sm text-[#828282] mb-3">
        Apakah Anda yakin ingin menghapus nomor <span class="font-semibold text-black">{{ displayPhone }}</span>?
      </p>

      <!-- Buttons -->
      <div class="d-flex align-items-center gap-2 justify-content-center">
        <b-button
          variant="outline-secondary"
          class="flex-1"
          :disabled="isLoading"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="flex-1"
          :disabled="isLoading"
          @click="onConfirm"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-1"
          />
          Hapus
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  apiGetFullWhatsAppList,
  apiDeleteWhatsApp,
} from './service/api.whatsApp.service'
import {
  formatDisplayPhone,
  formatRawPhone,
} from './helper/whatsAppPhoneHelper'

export default {
  name: 'ModalDeletePhoneNumber',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    itemToDelete: {
      type: [Object, String],
      default: () => null,
    },
    phoneData: {
      type: [Object, String],
      default: () => null,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalLoading: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.visible || this.value
      },
      set(val) {
        this.$emit('change', val)
        this.$emit('input', val)
        if (!val) {
          this.$emit('close')
        }
      },
    },
    targetItem() {
      return this.itemToDelete || this.phoneData
    },
    displayPhone() {
      if (!this.targetItem) return ''
      const phoneVal = typeof this.targetItem === 'object'
        ? this.targetItem.phone_number
        : this.targetItem
      return formatDisplayPhone(phoneVal)
    },
    isLoading() {
      return this.loading || this.isDeleting || this.internalLoading
    },
  },
  methods: {
    onCancel() {
      this.$emit('change', false)
      this.$emit('input', false)
      this.$emit('close')
    },
    async onConfirm() {
      if (this.$listeners && this.$listeners.confirm) {
        this.$emit('confirm', this.targetItem)
        return
      }

      if (!this.targetItem) return
      this.internalLoading = true
      try {
        let { id } = this.targetItem
        if (!id) {
          try {
            const fullRes = await apiGetFullWhatsAppList()
            const fullList = fullRes.data?.data || []
            const phoneVal = this.targetItem.phone_number || this.targetItem
            const matched = fullList.find(
              item => formatRawPhone(item.phone_number) === formatRawPhone(phoneVal),
            )
            if (matched?.id) {
              id = matched.id
            }
          } catch (e) {
            console.error('Failed to lookup whatsapp id:', e)
          }
        }

        if (id) {
          await apiDeleteWhatsApp(id)
        } else {
          throw new Error('ID nomor tidak ditemukan')
        }

        this.$toast_success({ message: 'Nomor berhasil dihapus' })
        if (this.$store?.dispatch) {
          this.$store.dispatch('whatsapp/getUpdateDashboardWa')
          this.$store.dispatch('komchat/getWhatsAppList')
        }
        this.$emit('deleted', this.targetItem)
        this.onCancel()
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.message || 'Gagal menghapus nomor'
        this.$toast_error({ message: errorMsg })
      } finally {
        this.internalLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
#modal-delete-phone {
  .modal-content {
    border-radius: 16px !important;
    border: none !important;
  }
}
</style>
